import React from 'react';

import { IndeterminateValue, isIndeterminate, PropertySelectField } from '@paragon/client-tools';
import { TrussType } from '@paragon/contract-library';
import { humanCase } from '@paragon/utilities';

interface Props {
  value: TrussType | IndeterminateValue;

  onChange(componentType: TrussType): void;

  disabled?: boolean;
}

export function TrussTypeSelect({ onChange, value, disabled }: Props) {
  return (
    <PropertySelectField<TrussType>
      margin="normal"
      property="Component Type"
      disabled={disabled}
      value={value}
      allowUnknownValues={isIndeterminate(value)}
      options={['RoofTruss', 'FloorTruss']}
      getName={humanCase}
      submit={onChange}
    />
  );
}
